import { asyncRoutes, constantRoutes } from '@/router'






const actions = {
  setPermission({ commit }, list) {
    commit('SET_PERMISSION', list)
  },
  setRoleId({ commit }, roleId) {
    commit('SET_ROLE', roleId)
  }
}





const state = {
  routes: [],
  addRoutes: [],
  permissionList: [],
  roleId:''
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_PERMISSION: (state, list) => {
    state.permissionList=list;
  },
  SET_ROLE: (state, roleId) => {
    state.roleId=roleId;
  }
}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
